/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const loginApi = platform.LoginApi;

export const getUserInfoKey = 'get-user-info';
export const verifyInvitationTokenKey = 'verify-invitation-token';
export const getCreateAccountOptions = 'get-create-account-options';
export const verifyResetPasswordTokenKey = 'verify-reset-password-token';
export const verifyConfirmationTokenKey = 'verify-confirmation-token';

export const useGetUserInfo = (userUuid: string) => {
    return useQuery([getUserInfoKey, userUuid], () => loginApi.getUserInfo(), {
        enabled: !!userUuid,
        staleTime: Infinity
    });
};

export const useVerifyInvitationToken = (token?: string) => {
    return useQuery([verifyInvitationTokenKey, token], () => loginApi.verifyInvitationToken({ token }), {
        enabled: !!token
    });
};

export const useVerifyResetPasswordToken = (token?: string) => {
    return useQuery([verifyResetPasswordTokenKey, token], () => loginApi.validateResetPasswordToken({ token }), {
        enabled: !!token
    });
};

export const useGetCreateAccountOptions = (token: string) => {
    return useQuery([getCreateAccountOptions, token], () => loginApi.getCreateAccountOptions(token), {
        enabled: !!token
    });
};

export const useGetCreateAccountOptionsConfirmationToken = (token: string) => {
    return useQuery([getCreateAccountOptions, token], () => loginApi.getCreateAccountOptionsConfirmationToken(token), {
        enabled: !!token
    });
};
export const useGetIsTenantLoginStrategy = () => {
    return useQuery([], () => loginApi.getLoginStrategy(), {
        cacheTime: 0
    });
};

export const useVerifyConfirmationToken = (token?: string) => {
    return useQuery([verifyConfirmationTokenKey, token], () => loginApi.verifyConfirmationToken({ token }), {
        enabled: !!token
    });
};
